import {BACKEND_API} from '../middleware/backend'

export const DOGS_REQUEST = 'DOGS_REQUEST';
export const DOGS_SUCCESS = 'DOGS_SUCCESS';
export const DOGS_FAILURE = 'DOGS_FAILURE';
export const DOGS_COUNT_REQUEST = 'DOGS_COUNT_REQUEST';
export const DOGS_COUNT_SUCCESS = 'DOGS_COUNT_SUCCESS';
export const DOGS_COUNT_FAILURE = 'DOGS_COUNT_FAILURE';
export const DOG_REQUEST = 'DOG_REQUEST';
export const DOG_SUCCESS = 'DOG_SUCCESS';
export const DOG_FAILURE = 'DOG_FAILURE';
export const DOGS_FIND_REQUEST = 'DOGS_FIND_REQUEST';
export const DOGS_FIND_SUCCESS = 'DOGS_FIND_SUCCESS';
export const DOGS_FIND_FAILURE = 'DOGS_FIND_FAILURE';
export const DOG_SAVE_REQUEST = 'DOG_SAVE_REQUEST';
export const DOG_SAVE_SUCCESS = 'DOG_SAVE_SUCCESS';
export const DOG_SAVE_FAILURE = 'DOG_SAVE_FAILURE';
export const DOG_INFO_REQUEST = 'DOG_INFO_REQUEST';
export const DOG_INFO_SUCCESS = 'DOG_INFO_SUCCESS';
export const DOG_INFO_FAILURE = 'DOG_INFO_FAILURE';

export const loadDogs = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [DOGS_REQUEST, DOGS_SUCCESS, DOGS_FAILURE],
			endpoint: "dog/list",
			filter: filter
		}
	})
};

export const countDogs = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [DOGS_COUNT_REQUEST, DOGS_COUNT_SUCCESS, DOGS_COUNT_FAILURE],
			endpoint: "dog/count",
			filter: filter
		}
	})
};

export const loadDog = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [DOG_REQUEST, DOG_SUCCESS, DOG_FAILURE],
			endpoint: `dog/${id}`,
		}
	})
};

export const findDogs = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [DOGS_FIND_REQUEST, DOGS_FIND_SUCCESS, DOGS_FIND_FAILURE],
			endpoint: "dog/find",
			filter: filter
		}
	})
};

export const saveDog = (dog) => (dispatch, getState) => {
	return dispatch({
		id: dog.dogId,
		dog: dog,
		[BACKEND_API]: {
			types: [DOG_SAVE_REQUEST, DOG_SAVE_SUCCESS, DOG_SAVE_FAILURE],
			endpoint: 'dog',
			body: dog,
			silent: true
		}
	})
};

export const loadDogInfo = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [DOG_INFO_REQUEST, DOG_INFO_SUCCESS, DOG_INFO_FAILURE],
			endpoint: `dog/info/${id}`,
		}
	})
};



// WEBPACK FOOTER //
// ./src/actions/dogs.js